import ReactDOM from 'react-dom/client';
import React from 'react';

import { Provider } from 'react-redux';

import App from './App';
import store from './stores/store';
import './utils/prototype'
import { GlobalProvider } from './providers/GlobalProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SocketProvider } from './providers/SocketProvider';
import { OrderProvider } from './providers/OrderProvider';
import UnsubscribePage from './pages/unsubscribe';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { dropWaiterSession } from './utils/waiter';

const root = ReactDOM.createRoot(document.getElementById('root'));

const page = window.location.pathname;

// Garçom usa só o app mobile: a sessão dele é descartada antes de montar a árvore (providers e páginas
// leem o token/usuário do localStorage na criação). Fora do login, vai direto para "/" sem renderizar.
const redirectingWaiter = dropWaiterSession() && page !== '/';
if (redirectingWaiter) {
  window.location.replace('/');
}
else if (page === '/unsubscribe') {
  root.render(
    <>
      <ToastContainer
        style={{ fontSize: "14px", zIndex: 999999 }}
        autoClose={2000}
        hideProgressBar={true}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/unsubscribe" element={<UnsubscribePage />} exact />
        </Routes>
      </BrowserRouter>
    </>
  );
}
else {
  root.render(
    <>
      <ToastContainer
        style={{ fontSize: "14px", zIndex: 999999 }}
        autoClose={2000}
        hideProgressBar={true}
      />
      <Provider store={store}>
        <GlobalProvider>
          <SocketProvider>
            <OrderProvider>
              <App />
            </OrderProvider>
          </SocketProvider>
        </GlobalProvider>
      </Provider>
    </>
  );

}

